import { create } from "zustand";

interface SidebarState {
  isMobileMenuOpen: boolean; // Tracks if the mobile sidebar is toggled open
  isSidebarPresentOnPage: boolean; // Tracks if the current page *should* have a sidebar
  toggleMobileMenu: () => void;
  setMobileMenuOpen: (isOpen: boolean) => void;
  setIsSidebarPresentOnPage: (isPresent: boolean) => void;
}

export const useSidebarStore = create<SidebarState>((set) => ({
  isMobileMenuOpen: false,
  isSidebarPresentOnPage: false,
  toggleMobileMenu: () =>
    set((state) => ({ isMobileMenuOpen: !state.isMobileMenuOpen })),
  setMobileMenuOpen: (isOpen: boolean) => set({ isMobileMenuOpen: isOpen }),
  setIsSidebarPresentOnPage: (isPresent: boolean) =>
    set({ isSidebarPresentOnPage: isPresent }),
}));
